import React, { useEffect, useRef, useState } from 'react'
import ModalDrag from '../../../../components/ModaDrag/ModalDrag'
import GlobalCss from '@/global.module.less'
import { ConfigProvider, Image, Pagination, Table } from 'antd'
import { FileTextOutlined, TableOutlined, VideoCameraOutlined, AudioOutlined } from '@ant-design/icons'
import zhCN from 'antd/lib/locale/zh_CN'
import * as constants from "@/constants/constants"
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import rehypeRaw from 'rehype-raw'

import css from '../../detail/dataset-detail.module.less'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter' // 代码高亮
//高亮的主题，还有很多别的主题，可以自行选择
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism'
import 'katex/dist/katex.min.css'


import 'katex/dist/katex.min.css'
import ReactPlayer from 'react-player'
import { AudioVisualizer } from 'react-audio-visualize'
//import JsonView from 'react18-json-view'
//import 'react18-json-view/src/style.css'
import XMLViewer from 'react-xml-viewer'
export const FileTableViewModal = (props:any) => {
  const {
    setPage,
    setPageSize,
    fileInfo,
    open,
    setOpen,
    fileContent,
    Columns,
    page,
    pageSize,
    actionCallback,
  } = props

  useEffect(() => {
    return () => {
      setPage(1)
      setPageSize(10)
    }
  }, [open])

  const ModalContent = (
    <div style={{height: 'calc(75vh - 80px)', display: 'flex', flexDirection: 'column' }}>
      <div
        className={css.tableTreeWapper}
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <ConfigProvider locale={zhCN}>
          <Table
            scroll={{ x: 'max-content', y: 'calc(75vh - 200px)' }}
            dataSource={fileContent}
            columns={Columns.map((item) => {
              // 通过配置 给每个单元格添加不换行属性
              const fun = () => ({
                style: { whiteSpace: 'nowrap', minWidth: '100px' },
              })
              item.onHeaderCell = fun
              item.onCell = fun
              return item
            })}
            pagination={false}
          />
        </ConfigProvider>
      </div>
      <div
        className={GlobalCss.pagination}
        style={{ textAlign: 'center', marginTop: '12px', padding: '0 4px 4px' }}
      >
        <ConfigProvider locale={zhCN}>
          <Pagination
            hideOnSinglePage
            current={page}
            pageSize={pageSize}
            total={fileInfo?.totalSum}
            onChange={(np, nps) => {
              setPage(np)
              setPageSize(nps)
              actionCallback({
                page: np,
                pagesize: nps,
                path_id: fileInfo?.path_id,
                dataset_id: fileInfo?.dataset_id,
                model_id:fileInfo?.model_id,
              })
            }}
          />
        </ConfigProvider>
      </div>
    </div>
  )
  return (
    <div>
      <ModalDrag
        destroyOnClose={false}
        width={1280}
        style={{ maxWidth: '92vw' }}
        bodyStyle={{ padding: '12px 16px 8px' }}
        onCancel={() => setOpen(false)}
        modalTitle={
          <span className={GlobalCss.modalTitle} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <TableOutlined style={{ color: '#4f46e5', fontSize: 15 }} />
            {fileInfo?.name}
          </span>
        }
        modalContent={ModalContent}
        open={open}
        footer={null}
      />
    </div>
  )
}

export const FileImageViewModal = (props:any) => {
  const { fileInfo, open, setOpen, fileContent } = props

  return (
    <div>
      <Image
        style={{ display: 'none', objectFit: 'contain' }}
        src={constants.BACKEND_API_URL  + fileContent}
        preview={{
          visible: open,
          src: constants.BACKEND_API_URL  + fileContent,
          onVisibleChange: (value) => {
            setOpen(value)
          },
        }}
      />
    </div>
  )
}

export const FileTextViewModal = (props:any) => {
  const { open, setOpen, fileContent, fileInfo } = props

  const ModalContentReactMarkdown = (
    <div
      style={{
        width: '100%',
        height: 'calc(78vh - 80px)',
        overflow: 'auto',
        boxSizing: 'border-box',
        padding: '4px 8px',
      }}
    >
      <ReactMarkdown
        remarkPlugins={[[remarkGfm, { singleTilde: false }], [remarkMath]]}
        rehypePlugins={[rehypeKatex, rehypeRaw]}
      >
        {fileContent}
      </ReactMarkdown>
    </div>
  )


  /*const ModalContentReactMarkdownPy = (
    <div
      style={{
        minWidth: '1130px',
        height: '680px',
        overflow: 'auto',
        margin: '20px auto',
      }}
    >

      <ReactMarkdown
        remarkPlugins={[
          [remarkGfm, { singleTilde: false }],
          [remarkMath],
        ]}
        rehypePlugins={[rehypeKatex, rehypeRaw]}
        components={{
          code({ node, inline, className, children , ...props }) {
            return !inline ? (
              <SyntaxHighlighter
                children={String(children).replace(/\n$/, '')}
                style={oneLight}
                language={'javascript'}
                PreTag="div"
                {...props}
              />
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            )
          },
        }}
      >
        {"```python \n" + fileContent + "\n```"}
      </ReactMarkdown>


    </div>
  )*/


  const ModalContentXML= (
    <div
      style={{
        width: '100%',
        height: 'calc(78vh - 80px)',
        overflow: 'auto',
        boxSizing: 'border-box',
        padding: '4px 8px',
      }}
    >
    <XMLViewer xml={fileContent} />

    </div>
  )

  return (
    <div>
      <ModalDrag
        destroyOnClose={false}
        width={1280}
        style={{ maxWidth: '92vw' }}
        bodyStyle={{ padding: '12px 16px 8px' }}
        onCancel={() => setOpen(false)}
        modalTitle={
          <span className={GlobalCss.modalTitle} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FileTextOutlined style={{ color: '#4f46e5', fontSize: 15 }} />
            {fileInfo?.name}
          </span>
        }
        modalContent={fileInfo?.name?.endsWith(".xml") ? ModalContentXML: ModalContentReactMarkdown}
        open={open}
        footer={null}
      />
    </div>
  )
}

export const FileVideoViewModal = (props:any) => {
  const { open, setOpen, fileContent, fileInfo } = props
  const playing = useRef<any>()

  const ModalContent = (
    <div
      style={{
        width: '100%',
        height: 'calc(72vh - 40px)',
        overflow: 'hidden',
        borderRadius: 8,
        background: '#000',
      }}
    >
      {open && (
        <video
          ref={playing}
          width={'100%'}
          height={'100%'}
          controls
          style={{ display: 'block', maxHeight: '100%' }}
          src={constants.BACKEND_API_URL + fileContent}
        />
      )}
    </div>
  )

  return (
    <div>
      <ModalDrag
        maskClosable={false}
        width={1100}
        style={{ maxWidth: '92vw' }}
        bodyStyle={{ padding: '12px 16px 8px' }}
        onCancel={() => {
          playing.current.pause()
          setOpen(false)
        }}
        modalTitle={
          <span className={GlobalCss.modalTitle} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <VideoCameraOutlined style={{ color: '#4f46e5', fontSize: 15 }} />
            {fileInfo?.name}
          </span>
        }
        modalContent={ModalContent}
        open={open}
        footer={null}
      />
    </div>
  )
}

export const FileAudioViewModal = (props:any) => {
  const { open, setOpen, fileContent, fileInfo } = props

  const audioRef = useRef<any>(null)
  const ModalContent = (
    <div
      style={{
        width: '330px',
        overflow: 'auto',
        margin: '0px auto',
        paddingTop:10,
      }}
    >
      <audio
      style={{width:330}}
        ref={audioRef}
        src={constants.BACKEND_API_URL + fileContent}
        controls
      ></audio>
    </div>
  )

  return (
    <div>
      <ModalDrag
        width={400}
        onCancel={() => {
          audioRef.current.pause()
          setOpen(false)
        }}
        modalTitle={
          <div
            style={{ width: '300px' }}
            className={
              GlobalCss.modalTitle + ' ' + GlobalCss.oneLineTextOverflow
            }
          >
            {fileInfo?.name}
          </div>
        }
        modalContent={ModalContent}
        open={open}
        footer={null}
      />
    </div>
  )
}

/*export const FileJsonViewModal = (props) => {
  const { open, setOpen, fileContent, fileInfo } = props

  const ModalContent = (
    <div
      style={{
        width: '1130px',
        height: '680px',
        overflow: 'auto',
        margin: '20px auto',
      }}
    >
      <JsonView src={fileContent} />
    </div>
  )

  return (
    <div>
      <ModalDrag
        destroyOnClose={false}
        width={1280}
        onCancel={() => setOpen(false)}
        modalTitle={<span className={GlobalCss.modalTitle}>{'预览数据'}</span>}
        modalContent={ModalContent}
        open={open}
        footer={null}
      />
    </div>
  )
}*/
